import { matchPath } from 'react-router'

import { useTranslation } from 'react-i18next'

import { useCallback } from 'react'
import { i18n } from 'i18next'

import { RouteConfig, Routes } from '../routes/routes'

import { useAppConfig } from './useAppConfig'

export function matchRoute(
  routes: RouteConfig,
  pathname: string | null,
  routeToMatch: Routes | string,
  currentLanguage: string,
  i18n: i18n
) {
  if (!pathname) return null

  const route = routes[routeToMatch]
  if (!route) return null

  const { localizationKey, sensitive } = route
  let path = `/${currentLanguage}`
  if (localizationKey) {
    path += i18n.t(`routes:${localizationKey}`)
  } else {
    path += i18n.t(`routes:${routeToMatch}`)
  }

  const matchedRout = matchPath(
    {
      path,
      caseSensitive: sensitive,
      end: true // This replaces the `exact` option
    },
    pathname
  )
  return matchedRout
}

export function useMatchRoute() {
  const { routes } = useAppConfig()
  const { i18n } = useTranslation(['routes'])

  const currentLanguage = i18n.language

  const matchRouteOverride = useCallback(
    (pathname: string | null, routeToMatch: Routes | string) => {
      return matchRoute(routes, pathname, routeToMatch, currentLanguage, i18n)
    },
    [currentLanguage, routes, i18n]
  )

  return {
    matchRoute: matchRouteOverride
  }
}
